import type { PublicRuntimeConfig } from 'app.types';
import getConfig from 'next/config';

export default function getBaseUrl(isServerSideFetch: boolean = false): string {
  const { publicRuntimeConfig } = getConfig();
  const { host, apiUrl, apiInternalUrl }: PublicRuntimeConfig = publicRuntimeConfig;

  // let baseUrl = host;

  let baseUrl = apiUrl;

  if (isServerSideFetch) {
    baseUrl = apiInternalUrl;
  }

  if (!baseUrl.endsWith('/')) {
    baseUrl = `${baseUrl}/`;
  }

  if (!baseUrl.startsWith('http')) {
    // baseUrl = `https://${baseUrl}`;
  }

  return baseUrl;
}

export function getBaseBillingUrl(): string {
  const { publicRuntimeConfig } = getConfig();
  const { host, apiBillingUrl, apiInternalBillingUrl }: PublicRuntimeConfig = publicRuntimeConfig;

  let baseUrl = host;

  // baseUrl = apiBillingUrl || 'https://billing-external.welltory.com/';
  baseUrl = apiInternalBillingUrl || 'https://billing-external.welltory.com/';

  if (!baseUrl.endsWith('/')) {
    baseUrl = `${baseUrl}/`;
  }

  if (!baseUrl.startsWith('http')) {
    baseUrl = `https://${baseUrl}`;
  }

  return baseUrl;
}
